import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-cf715cd6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "pre-order-steps" }
const _hoisted_2 = {
  class: /*#__PURE__*/_normalizeClass(['pre-order-steps__item-title'])
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.list, (item, index) => {
      return (_openBlock(), _createElementBlock("div", {
        key: index,
        class: _normalizeClass([`pre-order-steps__item pre-order-steps__item--${item.status}`])
      }, [
        _createElementVNode("div", _hoisted_2, _toDisplayString(item.title), 1),
        _createElementVNode("div", {
          class: "pre-order-steps__item-time",
          style: _normalizeStyle([!item.time && { visibility: 'hidden' }])
        }, _toDisplayString(item.time || "00:00"), 5)
      ], 2))
    }), 128))
  ]))
}